import { NormalizedProjectT } from './../../models/models';
import { SortingDirectionsE, StatusE } from './../../models/enums';
import { BASE_URL } from './../../api/config';
import authenticatedFetch from '../../utils/helpers/auth/authenticatedFetch';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ProjectT } from '../../models/models';

type ProjectsRequestBodyT = {
    limit?: number;
    page?: number;
    sort?: SortingDirectionsE;
    filterType?: string;
    filter?: string;
    string?: string;
    statusName?: string;
    projectType?: 'VideoAd' | 'AudioAd';
};

type ProjectBodyT = {
    id: number;
    detailed: boolean;
};

export const fetchProjectById = createAsyncThunk(
    'normalizedProjects/fetchProjectById',
    async ({ id, detailed }: ProjectBodyT) => {
        const response: any = await authenticatedFetch(
            BASE_URL + `api/Projects/UserGet/${id}?detailed=${detailed}`,
            { mode: 'cors' }
        );
    }
);

export const fetchProjects = createAsyncThunk(
    'normalizedProjects/fetchAllProjects',
    async (body: ProjectsRequestBodyT) => {
        const {
            limit = 10,
            page = 0,
            sort = SortingDirectionsE.DESC,
            filterType = 'name',
            filter = '',
            statusName = '',
            projectType = 'VideoAd',
        } = body;
        const queryParams = `?itemsPerPage=${limit || 10}&pageNumber=${page ? page - 1 : 0}&sortingOrder=${sort || SortingDirectionsE.DESC}&filterType=${filterType || 'name'}&filter=${filter || ''}&statusName=${statusName || ''}&projectType=${projectType || 'VideoAd'}`;
        const response: any = await authenticatedFetch(
            BASE_URL + `api/Projects/UserGet${queryParams}`,
            { mode: 'cors' }
        );

        const responseBody = await response.json();
        const projects: ProjectT[] = responseBody.Projects;
        const normalizedProjects: NormalizedProjectsStateI = {
            byId: {
            },
            allIds: [],
            totalCount: responseBody.ItemCount,
            isFetching: false,
        };

        projects.forEach(project => {
            //@ts-ignore
            normalizedProjects.byId[project.Id] = {
                id: project.Id,
                name: project.Name,
                number: project.Number,
                numberForClient: project.NumberForClient,
                postProductionCompanyInternalNumber: project.PostProductionCompanyInternalNumber as unknown as string,
                postProductionCompanyName: project.PostProductionCompanyName,
                statusName: project.StatusName as StatusE,
                versionCount: project.VersionCount,
                portfolioSettings: project.PortfolioSettings as null,
                advertiserName: project.AdvertiserName,
                advertisingAgencyName: project.AdvertisingAgencyName,
                approvalDate: project.ApprovalDate,
                brandName: project.BrandName,
                broadcasters: project.BroadcastersLogoInfo.map(info => ({
                    id: info.BroadcasterId,
                    name: info.BroadcasterName,
                    type: 0
                })),
                broadcastingDate: project.BroadcastingDate,
                creationDateTime: project.CreationDateTime,
                confirmationNumber: project.confirmation_number as unknown as string,
                lastUpdateDate: project.lastUpdateDate,
                sectorName: project.sectorName,
                campaign: {
                    fullId: project.campaign.CampaignId,
                    shortId: project.campaign.Id,
                    name: project.campaign.Name,
                    createdAt: project.campaign.Created,
                    updatedAt: project.campaign.Updated,
                },
                industry: {
                    id: project.industry.Id,
                    nameEn: project.industry.DisplayNameEn,
                    nameHe: project.industry.DisplayNameHe,
                    isExported: project.industry.IsExported,
                    kantarGroupCode: project.industry.KantarGroupCode,
                    kantarSectorCode: project.industry.KantarSectorCode,
                    sectorParentNameEN: project.industry.SectorParentNameEN,
                    sectorParentNameHE: project.industry.SectorParentNameHE,
                    status: project.industry.Status,
                    lastUsedDate: project.industry.lastUsedDate,
                    updated: project.industry.updated,
                    userId: project.industry.userId,
                },
            };
            normalizedProjects.allIds.push(project.Id);
        });

        return normalizedProjects;
    },
);

export interface NormalizedProjectsStateI {
    byId: {
        [key: string]: NormalizedProjectT;
    }
    allIds: number[];
    totalCount: number;
    isFetching: boolean;
};

const initialState: NormalizedProjectsStateI = {
    byId: {},
    allIds: [],
    totalCount: 0,
    isFetching: false,
};

const normalizedProjectsSlice = createSlice({
    name: 'normalizedProjects',
    initialState,
    reducers: {

    },
    extraReducers: builder => {
        builder.addCase(fetchProjects.pending, state => {
            state.isFetching = true;
        })
        builder.addCase(fetchProjects.fulfilled, (state, action: PayloadAction<NormalizedProjectsStateI>) => {
            state.byId = action.payload.byId;
            state.allIds = action.payload.allIds;
            state.totalCount = action.payload.totalCount;
            state.isFetching = action.payload.isFetching;
        });
        builder.addCase(fetchProjects.rejected, state => {
            state.isFetching = false;
        });
    },
});

export const { } = normalizedProjectsSlice.actions;

export default normalizedProjectsSlice.reducer;
